import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ location: string }>;

export const DispatchReset: HandlerType = props => {
    props.dispatch({
        type: "Components/ReCaptcha/Reset",
        location: props.parameter.location,
    });
};

export const chain = [DispatchReset];

const resetReCaptcha = createHandlerChainRunner(chain, "ResetReCaptcha");
export default resetReCaptcha;
